function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.002,358.003c43.659,0,83.349-15.479,114.307-41.674l138.915,138.915c3.175,3.175,7.144,4.763,11.51,4.763 c4.366,0,8.335-1.588,11.51-4.763c6.35-6.35,6.35-16.67,0-23.02L316.329,293.309c25.798-30.958,41.674-71.045,41.674-114.307 C358.003,80.174,277.829,0,179.002,0C80.571,0,0,80.571,0,179.002C0,277.829,80.571,358.003,179.002,358.003z M179.002,32.546 c80.967,0,146.456,65.885,146.456,146.456c0,80.967-65.488,146.456-146.456,146.456S32.546,259.572,32.546,179.002 C32.546,98.431,98.431,32.546,179.002,32.546z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 460.006 460.006"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-magnifying-glass.fc54f7f7.svg";
export { SvgComponent as ReactComponent };